// Extra translations for French (fr) and Italian (it).
// Merged into the main `translations` object at the bottom of
// `translations.js`. Adding a new language is a one-file change.

export const EXTRA_LANG_TRANSLATIONS = {
    // ---------------- HEADER ----------------
    header_tagline: {
        fr: "En cas d'urgence, toujours d'abord",
        it: "In caso di emergenza, sempre prima",
    },
    header_emergency_number: {
        fr: "Secours {num}",
        it: "Soccorsi {num}",
    },
    header_scan_call: { fr: "Scan & Call", it: "Scan & Call" },
    header_qr_hint: {
        fr: "Aide d'urgence par QR",
        it: "Aiuto d'emergenza tramite QR",
    },
    header_clear_location: {
        fr: "Supprimer l'emplacement enregistré",
        it: "Rimuovi posizione salvata",
    },

    // ---------------- LANGUAGE PICKER ----------------
    language_label: { fr: "Langue", it: "Lingua" },

    // ---------------- LANDING ----------------
    landing_emergency_title: { fr: "Urgence ?", it: "Emergenza?" },
    landing_emergency_sub: {
        fr: "Démarre l'aide guidée par la voix.",
        it: "Avvia l'aiuto guidato a voce.",
    },
    landing_demo_label: { fr: "Démo", it: "Demo" },
    landing_demo_title: {
        fr: "Je n'ai pas d'urgence mais je veux voir comment ça marche.",
        it: "Non ho un'emergenza ma voglio vedere come funziona.",
    },
    landing_demo_sub: { fr: "", it: "" },
    landing_unsure_full: {
        fr: "Pas sûr ? En cas de doute, lancez un {notruf} !",
        it: "Non sei sicuro? In caso di dubbio, fai una {notruf}!",
    },
    landing_unsure_notruf: {
        fr: "appel d'urgence",
        it: "chiamata d'emergenza",
    },
    landing_aed_button: {
        fr: "Ouvrir la carte des défibrillateurs",
        it: "Apri la mappa dei defibrillatori",
    },
    landing_aed_button_sub: {
        fr: "Trouver des défibrillateurs à proximité",
        it: "Trova defibrillatori nelle vicinanze",
    },
    landing_disclaimer_full: {
        fr: "Les informations fournies servent uniquement de point de repère. Leur utilisation se fait à vos propres risques et ne remplace pas votre propre évaluation de la situation ni les instructions professionnelles sur place. Aucune garantie d'exactitude. En cas de doute, composez toujours le {notruf}.",
        it: "Le informazioni fornite sono solo a scopo di orientamento. L'uso è a proprio rischio e non sostituisce la valutazione personale della situazione né le istruzioni professionali sul posto. Nessuna garanzia di correttezza. In caso di dubbio, chiama sempre il {notruf}.",
    },
    landing_disclaimer_notruf: {
        fr: "numéro d'urgence {num}",
        it: "numero di emergenza {num}",
    },
    landing_skip_to_cpr: {
        fr: "Passer directement à la réanimation",
        it: "Vai direttamente alla rianimazione",
    },
    landing_skip_to_cpr_sub: {
        fr: "En mode démo, sans questions de triage.",
        it: "In modalità demo, senza domande di triage.",
    },
    footer_privacy: { fr: "Confidentialité", it: "Privacy" },
    footer_imprint: { fr: "Mentions légales", it: "Note legali" },

    // ---------------- SCAN & CALL BANNER ----------------
    scancall_title: {
        fr: "Nous numérisons la chaîne de secours.",
        it: "Stiamo digitalizzando la catena dei soccorsi.",
    },
    scancall_sub: {
        fr: "Affiche premiers secours en quelques minutes – conforme DGUV et gratuit à vie.",
        it: "Cartello di primo soccorso in pochi minuti – conforme DGUV e gratis a vita.",
    },
    scancall_bullet_1: {
        fr: "Urgence, premiers secouristes et localisation en un coup d'œil",
        it: "Chiamata, primi soccorritori e posizione a colpo d'occhio",
    },
    scancall_bullet_2: {
        fr: "Directement sur le smartphone via QR code",
        it: "Direttamente sullo smartphone tramite QR code",
    },
    scancall_bullet_3: {
        fr: "Affiche conforme DGUV – immédiatement utilisable",
        it: "Cartello conforme DGUV – pronto all'uso subito",
    },
    scancall_cta: { fr: "Commencer", it: "Inizia ora" },

    // ---------------- EMAIL POPUP ----------------
    email_popup_title: { fr: "Reste informé(e)", it: "Resta aggiornato/a" },
    email_popup_body: {
        fr: "Merci d'essayer SafetyAssist. Nous améliorons cette aide d'urgence en continu. Laisse ton e-mail et reçois une mise à jour dès qu'une nouveauté arrive.",
        it: "Grazie per provare SafetyAssist. Stiamo migliorando costantemente questo aiuto d'emergenza. Lascia la tua e-mail e ricevi aggiornamenti non appena ci saranno novità.",
    },
    email_popup_email_placeholder: {
        fr: "vous@email.com",
        it: "tu@email.com",
    },
    email_popup_consent: {
        fr: "En envoyant, j'accepte que mon adresse e-mail soit enregistrée et utilisée pour recevoir les nouveautés SafetyAssist.",
        it: "Inviando, accetto che il mio indirizzo e-mail venga memorizzato e usato per inviarmi aggiornamenti su SafetyAssist.",
    },
    email_popup_submit: { fr: "S'inscrire", it: "Iscriviti" },
    email_popup_later: { fr: "Peut-être plus tard", it: "Forse più tardi" },
    email_popup_thanks: {
        fr: "Merci ! On revient vers toi dès qu'il y a du nouveau.",
        it: "Grazie! Ti contatteremo non appena ci saranno novità.",
    },
    email_popup_error_email: {
        fr: "Veuillez entrer une adresse e-mail valide.",
        it: "Inserisci un indirizzo e-mail valido.",
    },
    email_popup_error_consent: {
        fr: "Veuillez accepter l'enregistrement de votre adresse e-mail.",
        it: "Accetta la memorizzazione del tuo indirizzo e-mail.",
    },

    // ---------------- SAFETY BRIEFING ----------------
    safety_title: {
        fr: "Consignes de sécurité",
        it: "Istruzioni di sicurezza",
    },
    safety_line_1: { fr: "Restez calme !", it: "Mantieni la calma!" },
    safety_line_2: {
        fr: "Sécurisez le lieu de l'accident !",
        it: "Metti in sicurezza il luogo dell'incidente!",
    },
    safety_line_3: {
        fr: "Veillez à votre propre sécurité.",
        it: "Fai attenzione alla tua sicurezza.",
    },
    safety_line_4: {
        fr: "Si nécessaire, mettez la personne hors de la zone de danger.",
        it: "Se necessario, sposta la persona fuori dall'area di pericolo.",
    },
    safety_hint: {
        fr: "Tu n'es pas seul – le {num} reste accessible en haut à tout moment.",
        it: "Non sei solo – il {num} è raggiungibile in alto in qualsiasi momento.",
    },
    safety_continue: { fr: "Continuer", it: "Continua" },

    // ---------------- TRIAGE ----------------
    triage_assessment: {
        fr: "Évaluation initiale",
        it: "Valutazione iniziale",
    },
    triage_demo_badge: { fr: "Démo", it: "Demo" },
    triage_check_person: {
        fr: "Vérifier la personne",
        it: "Controlla la persona",
    },
    triage_question_label: { fr: "Question", it: "Domanda" },
    triage_consciousness_title: {
        fr: "La personne est-elle consciente ?",
        it: "La persona è cosciente?",
    },
    triage_consciousness_sub: { fr: "Réactive", it: "Reattiva" },
    triage_consciousness_tts: {
        fr: "La personne est-elle consciente ? Réagit-elle ?",
        it: "La persona è cosciente? È reattiva?",
    },
    triage_advice_conscious_title: {
        fr: "Aidez selon la situation",
        it: "Aiuta a seconda della situazione",
    },
    triage_advice_conscious_body: {
        fr: "ex. soigner une plaie, calmer la personne, protéger de l'hypothermie.",
        it: "es. medicare la ferita, calmare la persona, proteggerla dall'ipotermia.",
    },
    triage_advice_conscious_tts: {
        fr: "Aidez en fonction de la situation, par exemple soignez la plaie. Appuyez ensuite sur le grand bouton rouge d'urgence.",
        it: "Aiuta in base alla situazione, ad esempio medica la ferita. Poi premi il grande pulsante rosso d'emergenza.",
    },
    triage_breathing_title: {
        fr: "La personne respire-t-elle ?",
        it: "La persona respira?",
    },
    triage_breathing_sub: {
        fr: "Voir, écouter, sentir",
        it: "Guarda, ascolta, senti",
    },
    triage_breathing_tts: {
        fr: "La personne respire-t-elle ? Vérifiez en regardant, en écoutant et en touchant.",
        it: "La persona respira? Controlla guardando, ascoltando e sentendo.",
    },
    triage_advice_breathing_title: {
        fr: "Position latérale de sécurité",
        it: "Posizione laterale di sicurezza",
    },
    triage_advice_breathing_body: {
        fr: "Mettez la personne en position latérale de sécurité et surveillez la respiration.",
        it: "Metti la persona in posizione laterale di sicurezza e controlla la respirazione.",
    },
    triage_advice_breathing_tts: {
        fr: "Mets la personne en position latérale de sécurité. Appuie ensuite sur le grand bouton rouge d'urgence.",
        it: "Metti la persona in posizione laterale di sicurezza. Poi premi il grande pulsante rosso d'emergenza.",
    },
    triage_advice_no_breath_title: {
        fr: "Pas de conscience ni de respiration – Appelez immédiatement",
        it: "Niente coscienza né respiro – Chiamata immediata",
    },
    triage_advice_no_breath_body: {
        fr: "Composez immédiatement le {num} et commencez le massage cardiaque (30:2).",
        it: "Chiama subito il {num} e inizia il massaggio cardiaco (30:2).",
    },
    triage_advice_no_breath_tts: {
        fr: "Pas de conscience et pas de respiration. Appuyez immédiatement sur le grand bouton rouge d'urgence et commencez la réanimation.",
        it: "Nessuna coscienza e nessun respiro. Premi subito il grande pulsante rosso d'emergenza e inizia la rianimazione.",
    },
    triage_yes: { fr: "Oui", it: "Sì" },
    triage_no: { fr: "Non", it: "No" },
    triage_advice_label: { fr: "Recommandation", it: "Raccomandazione" },
    triage_emergency_call: { fr: "Urgence {num}", it: "Emergenza {num}" },
    triage_demo_alert_urgent: {
        fr: "En situation réelle, l'appel au {num} serait déclenché ici.",
        it: "In una vera emergenza, qui verrebbe avviata la chiamata al {num}.",
    },
    triage_demo_alert_generic: {
        fr: "En situation réelle, l'appel au {num} serait déclenché ici.",
        it: "In una vera emergenza, qui verrebbe avviata la chiamata al {num}.",
    },

    breadcrumb_conscious_no: { fr: "Pas de conscience", it: "Niente coscienza" },
    breadcrumb_conscious_yes: { fr: "Conscient(e)", it: "Cosciente" },
    breadcrumb_breathing_no: { fr: "Ne respire pas", it: "Non respira" },
    breadcrumb_breathing_yes: { fr: "Respire", it: "Respira" },
    breadcrumb_called_112: {
        fr: "Appel d'urgence passé",
        it: "Chiamata d'emergenza effettuata",
    },

    demo_banner_label: { fr: "Mode démo actif", it: "Modalità demo attiva" },
    demo_tts_prefix: { fr: "Mode démo.", it: "Modalità demo." },

    // ---------------- CPR ----------------
    cpr_waiting_title: {
        fr: "Appel du {num}…",
        it: "Chiamata al {num}…",
    },
    cpr_waiting_body: {
        fr: "Parlez avec le centre d'appels. Dès que vous revenez dans l'app, la réanimation guidée démarre automatiquement.",
        it: "Parla con la centrale operativa. Appena torni nell'app, la rianimazione guidata inizia automaticamente.",
    },
    cpr_start_now: { fr: "Démarrer maintenant", it: "Avvia ora" },
    cpr_intro_title: {
        fr: "Effectuer la réanimation",
        it: "Eseguire la rianimazione",
    },
    cpr_intro_body: {
        fr: "Appuyez deux fois par seconde – 30 fois, puis 2 insufflations.",
        it: "Premi due volte al secondo – 30 volte, poi 2 ventilazioni.",
    },
    cpr_intro_tts: {
        fr: "Effectuer la réanimation. Appuyez deux fois par seconde, trente fois, puis donnez deux insufflations.",
        it: "Eseguire la rianimazione. Premi due volte al secondo, trenta volte, poi esegui due ventilazioni.",
    },
    cpr_start_immediately: { fr: "Continuer", it: "Continua" },
    cpr_active_title: {
        fr: "Effectuez la RCP !",
        it: "Esegui la rianimazione!",
    },
    cpr_reanimation: { fr: "Réanimation", it: "Rianimazione" },
    cpr_counter_compressions: {
        fr: "{n}/30 compressions",
        it: "{n}/30 compressioni",
    },
    cpr_counter_breaths: { fr: "{n}/2 insufflations", it: "{n}/2 ventilazioni" },
    cpr_label_compress: { fr: "Pousser", it: "Premi" },
    cpr_label_breathe: { fr: "Insuffler", it: "Ventila" },
    cpr_bpm_line: {
        fr: "110 BPM · 545 ms par compression",
        it: "110 BPM · 545 ms per compressione",
    },
    cpr_timer_suffix: {
        fr: "30× compressions · 2× insufflations",
        it: "30× compressioni · 2× ventilazioni",
    },
    cpr_continue_hint: {
        fr: "Continuez jusqu'à l'arrivée des secours.",
        it: "Continua fino all'arrivo dei soccorsi.",
    },
    cpr_handover_tts: {
        fr: "Demandez un relais !",
        it: "Chiedi un cambio!",
    },
    cpr_breath_tts: { fr: "Insuffler", it: "Ventila" },
    cpr_show_aed: {
        fr: "Défibrillateur à proximité",
        it: "Defibrillatore nelle vicinanze",
    },

    // ---------------- AED ----------------
    aed_back: { fr: "Retour", it: "Indietro" },
    aed_section_label: {
        fr: "Recherche de défibrillateur",
        it: "Ricerca defibrillatore",
    },
    aed_confirm_title: {
        fr: "Êtes-vous toujours à cet emplacement ?",
        it: "Ti trovi ancora in questo luogo?",
    },
    aed_confirm_yes: { fr: "Oui, continuer", it: "Sì, continua" },
    aed_confirm_no: {
        fr: "Non, nouvel emplacement",
        it: "No, nuova posizione",
    },
    aed_detecting_title: {
        fr: "Localisation en cours…",
        it: "Rilevamento posizione…",
    },
    aed_detecting_sub: {
        fr: "Autorisez l'accès à la localisation dans la fenêtre du navigateur.",
        it: "Autorizza l'accesso alla posizione nella finestra del browser.",
    },
    aed_detecting_hint: {
        fr: "Si la fenêtre n'apparaît pas ou si vous l'avez refusée, vous pouvez aussi entrer un code postal.",
        it: "Se la finestra non appare o l'hai rifiutata, puoi anche inserire un CAP.",
    },
    aed_enter_plz: { fr: "Saisir le code postal", it: "Inserisci CAP" },
    aed_manual_title: { fr: "Saisir le code postal", it: "Inserisci CAP" },
    aed_manual_sub: {
        fr: "Accès à la localisation désactivé – entrez votre code postal pour trouver les défibrillateurs à proximité.",
        it: "Accesso alla posizione non attivo – inserisci il CAP per trovare i defibrillatori nelle vicinanze.",
    },
    aed_manual_hint: {
        fr: "Astuce : tu peux réautoriser la localisation si ton navigateur le permet.",
        it: "Suggerimento: puoi riattivare l'accesso alla posizione se il tuo browser lo supporta.",
    },
    aed_find_button: {
        fr: "Trouver des défibrillateurs",
        it: "Trova defibrillatori",
    },
    aed_retry_gps: { fr: "Réessayer GPS", it: "Riprova GPS" },
    aed_toast_invalid_plz: {
        fr: "Veuillez entrer un code postal valide à 5 chiffres.",
        it: "Inserisci un CAP valido di 5 cifre.",
    },
    aed_toast_plz_failed: {
        fr: "Le code postal n'a pas pu être résolu.",
        it: "CAP non risolvibile.",
    },
    aed_toast_no_geo: {
        fr: "La géolocalisation n'est pas prise en charge par le navigateur.",
        it: "La geolocalizzazione non è supportata dal browser.",
    },
    aed_toast_geo_denied: {
        fr: "Autorisation de localisation refusée ou échec.",
        it: "Permesso di localizzazione negato o non riuscito.",
    },
    aed_placeholder_plz: { fr: "ex. 10115", it: "es. 10115" },

    // ---------------- DEFIBRILLATOR MAP ----------------
    map_section_label: {
        fr: "Défibrillateurs à proximité",
        it: "Defibrillatori nelle vicinanze",
    },
    map_count: {
        fr: "{n} emplacements de défibrillateur",
        it: "{n} posizioni di defibrillatori",
    },
    map_your_location: { fr: "Votre position", it: "La tua posizione" },
    map_aed_label: { fr: "Défibrillateur", it: "Defibrillatore" },
    map_you_are_here: { fr: "Vous êtes ici", it: "Sei qui" },
    map_operator: { fr: "Exploitant", it: "Operatore" },
    map_indoor: { fr: "Intérieur", it: "All'interno" },
    map_outdoor: { fr: "Extérieur", it: "All'esterno" },
    map_opening_hours: { fr: "Heures d'ouverture", it: "Orari di apertura" },

    // ---------------- COMMON ----------------
    tts_activate: { fr: "Activer la voix", it: "Attiva voce" },
    tts_mute: { fr: "Couper la voix", it: "Disattiva voce" },
    reset_link: {
        fr: "Recommencer – revenir au début",
        it: "Ricomincia – torna all'inizio",
    },
    footer_powered_by: {
        fr: "Propulsé par SafetyAssist",
        it: "Realizzato con SafetyAssist",
    },
};
